import React, { useState } from 'react'
import Loader from '../Loader/Loader'
import { message, Button } from "antd";
import { useFormik } from 'formik'
import * as Yup from "yup";
import { updateRelationCategory } from '../../Web Apis/Apis'
import { useRef } from 'react';

function UpdateRelation({ showUpdateModalOpen, setShowUpdateModalOpen, action, setAction, selectedCategory }) {

    const [open, setOpen] = useState(showUpdateModalOpen)
    const [loading, setLoading] = useState(false)
    const [image, setImage] = useState(selectedCategory.relationImage)

    const handleCloseModal = () => {
        setOpen(false)
        setShowUpdateModalOpen(false)
    }

    const formik = useFormik(
        {
            initialValues: {
                relationName: selectedCategory.subcategory,
                relationImage: selectedCategory.image
            },
            validationSchema: Yup.object({
                relationName: Yup.string().required("Category name is required")
                    .max(50, "Category name should not be more than 50 characters")
                    .min(3, "Category name should be atleast 3 characters long")
                    .trim("Category name should not have spaces"),
                    
                relationImage: Yup.string().required("Category image is required")
            }),
            onSubmit: async (values, { resetForm, setSubmitting }) => {
                try {
                    setLoading(true)

                    const response = await updateRelationCategory(
                        selectedCategory.id,
                        {
                            ...values
                        }
                    )

                    if (response?.data?.success) {
                        message.success(response?.data?.message)
                        resetForm()
                        setOpen()
                        setShowUpdateModalOpen(false)
                        setAction(!action)
                    }

                } catch (error) {
                    console.log("Error while creating admin", error.message)
                    message.error(error?.response?.data?.message || "Error while updating relation category")
                } finally {
                    setSubmitting(false)
                    setLoading(false)
                }
            }

        }
    )

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            formik.setFieldValue("relationImage", file);
        }
    };

    const fileInputRef = useRef(selectedCategory.relationImage || null)
    const handleRemoveImage = () => {
        setImage(null);
        formik.setFieldValue("relationImage", null);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";  // Reset the file input field
        }
    };


    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-2xl shadow-lg w-[600px] h-[500px] overflow-y-auto">

                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                    Update Relation Category
                </h3>

                <form onSubmit={formik.handleSubmit} className='p-8'>

                    <div className="w-full">
                        <label className="block mb-4 mt-2 text-xl font-bold">Occassion image:</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="cursor-pointer text-2xl"
                            ref={fileInputRef}
                        />

                        {formik.touched.relationImage && formik.errors.relationImage && (
                            <p className="text-red-600">{formik.errors.relationImage}</p>
                        )}

                        {image && (
                            <div className="mt-2 flex items-center border border-gray-800">
                                <img
                                    src={image}
                                    alt="Profile Preview"
                                    className="border border-gray-800 w-16 h-16 object-cover rounded-full mr-2"
                                />
                                <Button
                                    type="button"
                                    className="bg-red-600 text-white cursor-pointer"
                                    onClick={handleRemoveImage}
                                >
                                    Remove Image
                                </Button>
                            </div>
                        )}
                    </div>

                    <div className="w-full">
                        <label className="block mb-1 mt-8 text-xl font-bold">Relation Name :</label>
                        <input
                            type="text"
                            name="relationName"
                            className="border border-gray-800 p-2 w-full "
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.relationName}
                            placeholder='Enter occassion category name'
                        />
                        {formik.touched.relationName && formik.errors.relationName && (
                            <p className="text-red-600 ml-2">{formik.errors.relationName}</p>
                        )}
                    </div>

                    <div className="flex justify-center gap-6 mt-6">
                        <button
                            onClick={handleCloseModal}
                            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                        >
                            Update
                        </button>
                    </div>
                    {loading && <Loader />}


                </form>
            </div>
        </div>
    )
}

export default UpdateRelation